import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { forkJoin } from 'rxjs';
import { RelatedAccount, ServiceRequestHistoryDataOut } from 'src/app/_modules/customers/_models/kyc-account-data';
import { KycCustomerApiService } from 'src/app/_modules/customers/_services/kyc-customer-api.service';

@Component({
  selector: 'app-meter-request-section',
  templateUrl: './meter-request-section.component.html',
  styleUrls: ['./meter-request-section.component.scss'],
})
export class MeterRequestSectionComponent implements OnChanges {
  @Input() relatedAccounts: RelatedAccount[] | null | undefined;
  @Input() accountKycId: number = 0;

  historiesByAccountId: Record<number, ServiceRequestHistoryDataOut[]> = {};

  isHistoryModalVisible = false;
  selectedRelatedAccountId: number | null = null;
  selectedHistory: ServiceRequestHistoryDataOut[] = [];

  constructor(private kycCustomerApiService: KycCustomerApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['relatedAccounts']) {
      this.loadHistories();
    }
  }

  private loadHistories() {
    const accounts = (this.relatedAccounts ?? []).filter(
      (account): account is RelatedAccount & { id: number; accountNumber: string } =>
        account.id != null && !!account.accountNumber
    );

    if (!accounts.length) {
      this.historiesByAccountId = {};
      return;
    }

    forkJoin(
      accounts.map((account) =>
        this.kycCustomerApiService.getServiceRequestHistory(this.accountKycId, account.accountNumber)
      )
    ).subscribe((responses: any[]) => {
      const historiesByAccountId: Record<number, ServiceRequestHistoryDataOut[]> = {};
      responses.forEach((response, index) => {
        historiesByAccountId[accounts[index].id] = response?.data ?? [];
      });
      this.historiesByAccountId = historiesByAccountId;
    });
  }

  viewAccount(account: RelatedAccount) {
    if (account.id == null) return;

    this.selectedRelatedAccountId = account.id;
    this.selectedHistory = [...(this.historiesByAccountId[account.id] ?? [])].sort((a, b) =>
      new Date(b.applicationDate ?? 0).getTime() - new Date(a.applicationDate ?? 0).getTime()
    );
    this.isHistoryModalVisible = true;
  }

  closeHistoryModal() {
    this.isHistoryModalVisible = false;
  }
}
